module.exports = __webpack_public_path__ + "static/media/option-selected.ecaffa79.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/option-selected.svg
// module id = 191
// module chunks = 0